import httpClient from 'axios'
const http = httpClient.create({
	baseURL: 'https://seller.dhgate.com',
	timeout: 5000,
	withCredentials: true
})
const http1 = httpClient.create({
	baseURL: 'https://adcenter.dhgate.com',
	timeout: 5000,
	withCredentials: true
})
http.interceptors.request.use(
	config => {
		const headers = config.headers
		config.headers = headers
		//购物车
		if (config.url.includes('/cart.do')) {
			config.headers.common['Accept'] = '*/*;'
		}
		return config
	},
	error => {
		// 对请求错误做些什么
		return Promise.reject(error)
	}
)
http1.interceptors.request.use(
	config => {
		const headers = config.headers
		config.headers = headers
		
		return config
	},
	error => {
		// 对请求错误做些什么
		return Promise.reject(error)
	}
)

// 添加响应拦截器
http.interceptors.response.use(response => {
	return response.data
	},
	error => {
		// 对响应错误做点什么
		if (error && error.response) {
			switch (error.response.status) {
				case 400:
					error.message = '请求错误'
					break
				case 401:
					error.message = '请求无权限'
					break
				case 403:
					error.message = '拒绝访问'
					break
				case 404:
					error.message = `请求地址出错`
					break
				case 408:
					error.message = '请求超时'
					break
				case 500:
					error.message = '服务器内部错误'
					break
				case 501:
					error.message = '服务未实现'
					break
				case 502:
					error.message = '502 bad gateway'
					break
				case 503:
					error.message = '服务不可用'
					break
				case 504:
					error.message = '504错误 超时'
					break
				case 505:
					error.message = 'HTTP版本不受支持'
					break
				default:
			}
		}
		return Promise.reject(error)
})

http1.interceptors.response.use(response => {
	return response.data
	},
	error => {
		// 对响应错误做点什么
		if (error && error.response) {
			switch (error.response.status) {
				case 400:
					error.message = '请求错误'
					break
				case 401:
					error.message = '请求无权限'
					break
				case 403:
					error.message = '拒绝访问'
					break
				case 404:
					error.message = `请求地址出错`
					break
				case 408:
					error.message = '请求超时'
					break
				case 500:
					error.message = '服务器内部错误'
					break
				case 501:
					error.message = '服务未实现'
					break
				case 502:
					error.message = '502 bad gateway'
					break
				case 503:
					error.message = '服务不可用'
					break
				case 504:
					error.message = '504错误 超时'
					break
				case 505:
					error.message = 'HTTP版本不受支持'
					break
				default:
			}
		}
		return Promise.reject(error)
})

export {http, http1}
